import R from 'ramda'

// Mapping form actions to widget actions

import {
  isHashtagFormTrigger,
  convertHashtagFormTriggerToWidgetTrigger
} from './form-to-widget/hashtag'
import {
  isKeywordFormTrigger,
  convertKeywordFormTriggerToWidgetTrigger
} from './form-to-widget/keyword'
import {
  isMentionFormTrigger,
  convertMentionFormTriggerToWidgetTrigger
} from './form-to-widget/mention'
import {
  isOnlyFormTrigger,
  convertOnlyFormTriggerToWidgetTrigger
} from './form-to-widget/only'
import {
  isCommentsOnFormTrigger,
  convertCommentsOnFormTriggerToWidgetTrigger
} from './form-to-widget/comments-on-post'

// Mapping widget actions to form actions

import {
  isHashtagWidgetTrigger,
  convertHashtagWidgetTriggerToFormTrigger
} from './widget-to-form/hashtag'
import {
  isKeywordWidgetTrigger,
  convertKeywordWidgetTriggerToFormTrigger
} from './widget-to-form/keyword'
import {
  isMentionWidgetTrigger,
  convertMentionWidgetTriggerToFormTrigger
} from './widget-to-form/mention'
import {
  isOnlyWidgetTrigger,
  convertOnlyWidgetTriggerToFormTrigger
} from './widget-to-form/only'
import {
  isCommentsOnWidgetTrigger,
  convertCommentsOnWidgetTriggerToFormTrigger
} from './widget-to-form/comments-on'

const mapInstagramFormTriggersToWidgetTriggers = R.map(
  R.cond([
    [isHashtagFormTrigger, convertHashtagFormTriggerToWidgetTrigger],
    [isKeywordFormTrigger, convertKeywordFormTriggerToWidgetTrigger],
    [isMentionFormTrigger, convertMentionFormTriggerToWidgetTrigger],
    [isOnlyFormTrigger, convertOnlyFormTriggerToWidgetTrigger],
    [isCommentsOnFormTrigger, convertCommentsOnFormTriggerToWidgetTrigger],
    [R.T, R.identity]
  ])
)

const mapInstagramWidgetTriggersToFormTriggers = R.pipe(
  R.map(
    R.cond([
      [isHashtagWidgetTrigger, convertHashtagWidgetTriggerToFormTrigger],
      [isKeywordWidgetTrigger, convertKeywordWidgetTriggerToFormTrigger],
      [isMentionWidgetTrigger, convertMentionWidgetTriggerToFormTrigger],
      [isOnlyWidgetTrigger, convertOnlyWidgetTriggerToFormTrigger],
      [isCommentsOnWidgetTrigger, convertCommentsOnWidgetTriggerToFormTrigger],
      [R.T, R.identity]
    ])
  )
)

export {
  mapInstagramFormTriggersToWidgetTriggers,
  mapInstagramWidgetTriggersToFormTriggers
}



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/triggers/instagram/index.js